var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"round-button green",attrs:{"type":"button","title":_vm.translate('Add')},on:{"click":function($event){return _vm.$emit('add-item')}}},[_vm._v("\n        "+_vm._s("+")+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }